// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".glide__arrow{background-color:#fff;border:1px solid #c2c2c2}.glide__arrow i{color:#535353}.glide__arrow--left{left:16px}.glide__arrow--right{right:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
